(ns frontend.view.modals.curtains.pipeline-settings-curtain.events
  (:require
   [frontend.actions.entity :as entity-actions]
   [frontend.actions.stages :as stage-actions]
   [frontend.routing :as routing]
   [reagent.core :as r]
   [frontend.state.current-session :as session]
   [common.localization :as loc]
   [frontend.logging :as logging]
   [clojure.string :as string]
   [frontend.actions.opportunity-stages :as opportunity-stage-actions]
   [frontend.actions.sales-opportunity-stages :as sales-opportunity-stage-actions]
   [frontend.actions.exit-opportunity-stages :as exit-opportunity-stage-actions]
   [common.schema.constraints :as constraints]
   [common.schema.entity-creator.utils :as ecu]))

(defn start-edit!
  [edit-state stage]
  (reset! edit-state stage))

(defn end-edit!
  [edit-state]
  (reset! edit-state nil))

(defn tooltip
  [_pipeline edit-state field-schema stage-name-attribute]
  (let [id (:db/id @edit-state)
        stage-name (get @edit-state stage-name-attribute)
        field-constraints (:field/constraints field-schema)
        errors (constraints/validate
                field-constraints
                id
                stage-name
                @edit-state
                (partial session/unique-check false (partial routing/open-entity))
                loc/tr)]
    (cond (string/blank? stage-name)
          (loc/tr :name-cannot-be-blank)
          errors
          (loc/tr :constraint-violation/name-not-unique)
          :else nil)))

(defn save!
  [edit-state stage-name-attribute old-name entity-id]
  (let [new-name (get @edit-state stage-name-attribute)
        entity-atom (r/cursor session/entities [entity-id])
        updates (merge {}
                       (when (not= new-name old-name)
                         {stage-name-attribute new-name}))]
    (when-not (empty? updates)
      ;;optimistic save to frontend db:
      (swap! entity-atom assoc stage-name-attribute new-name)
      (entity-actions/*->entity-update! entity-id
                                        updates
                                        (fn [_] (end-edit! edit-state))
                                        (fn [err]
                                          ;;retract the optimistic save
                                          (when (= new-name (get @entity-atom stage-name-attribute))
                                            (swap! entity-atom assoc stage-name-attribute old-name))
                                          (logging/error "Failed to update stage : " err))))))

(defn toggle-prevent-create!
  [{:keys [pipeline-id stage-id]}]
  (let [pipeline-atom (r/cursor session/entities [pipeline-id])
        config-attribute :pipeline/creator-config
        pipeline @pipeline-atom
        old-config (get pipeline config-attribute)
        new-config (ecu/toggle-prevent-create-config old-config stage-id)
        updates (when (not= old-config new-config)
                  {config-attribute new-config})]
    (when (seq updates)
      ;;optimistic save to frontend db:
      (swap! pipeline-atom assoc config-attribute new-config)
      (entity-actions/*->entity-update!
       pipeline-id
       updates
       (fn [_])
       (fn [err]
         ;;retract the optimistic save
         (when (= new-config (get @pipeline-atom config-attribute))
           (swap! pipeline-atom assoc config-attribute old-config))
         (logging/error "Failed to update creation-config: " err))))))

(defn reorder!
  [moved-entity-id source-index destination-index on-success! on-error!]
  (let [moved-entity (get @session/entities moved-entity-id)]
    (case (:entity/type moved-entity)
      :entity.type/stage
      (let [pipeline-id (:stage/pipeline moved-entity)]
        (stage-actions/*->reorder! {:pipeline-id       pipeline-id
                                    :source-index      source-index
                                    :destination-index destination-index}
                                   on-success!
                                   on-error!))
      :entity.type/opportunity-stage
      (let [pipeline-id (:opportunity-stage/pipeline moved-entity)]
        (opportunity-stage-actions/*->reorder! {:pipeline-id       pipeline-id
                                                :source-index      source-index
                                                :destination-index destination-index}
                                               on-success!
                                               on-error!))
      :entity.type/sales-opportunity-stage
      (let [pipeline-id (:sales-opportunity-stage/pipeline moved-entity)]
        (sales-opportunity-stage-actions/*->reorder! {:pipeline-id       pipeline-id
                                                      :source-index      source-index
                                                      :destination-index destination-index}
                                                     on-success!
                                                     on-error!))
      :entity.type/exit-opportunity-stage
      (let [pipeline-id (:exit-opportunity-stage/pipeline moved-entity)]
        (exit-opportunity-stage-actions/*->reorder! {:pipeline-id       pipeline-id
                                                     :source-index      source-index
                                                     :destination-index destination-index}
                                                    on-success!
                                                    on-error!)))))

(defn view
  [data-state]
  (cond (:processing @data-state) :processing
        :else :normal))
